/* eslint jsx-a11y/anchor-is-valid: 0 */
import React, { Component } from "react";
import firebase from 'firebase/compat/app';
import { getUserLocale } from 'get-user-locale';
import {
  Container,
  Row,
  Col,
  Card,
  Button, Form, FormInput, FormGroup, FormFeedback
} from "shards-react";
import { WEBSITE_URL } from "../../environmentVariables";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faLock, faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import { useAnimation } from "../../contexts/AnimationContext";
import { useNavigate } from "react-router-dom";

const language = (getUserLocale() && getUserLocale().length === 5) ? getUserLocale() : 'en_US';
const locale = language.substr(-2).toLowerCase();

// Animation wrapper component
const AnimatedLoginWrapper = (props) => {
  const { animationDirection, setDirection } = useAnimation();
  const navigate = useNavigate();
  
  const goToForgotPassword = (e) => {
    e.preventDefault();
    setDirection('to-forgot');
    setTimeout(() => {
      navigate('/forgot-password');
    }, 300); // Transition duration
  };
  
  return <LoginComponent {...props} animationDirection={animationDirection} goToForgotPassword={goToForgotPassword} />;
};

class LoginComponent extends Component {
  constructor(props) {
    super(props)
    props.logout()
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.user
      && nextProps.user.id
      && nextProps.locations
      && nextProps.loadedLocations
      && nextProps.clients
      && nextProps.clients.length > 0
      && nextProps.users
      && nextProps.users.length > 0
    ) {
      if (nextProps?.user?.type === 'tenant') {
        window.location.href = '/tenant-vehicles';
      } else {
        window.location.href = '/dashboard';
      }
    }
    if (nextProps.user && nextProps.user.id && this.props.user !== nextProps.user) {
      nextProps.getLiveUsers(nextProps.user.id)
      nextProps.getLiveClients(nextProps.user.id)
    }
    if (nextProps.clients && nextProps.clients.length !== this.props.clients.length && nextProps.clients.length > 0) {
      nextProps.getLiveLocations(nextProps.user.id)
      
    }
    if (nextProps.loginFail && nextProps.loginFail !== this.props.loginFail) {
      this.setState({loggingIn: false})
    }
  }

  state = {
    email: null,
    password: null,
    loggingIn: false,
  };

  render() {
    const { animationDirection } = this.props;
    const animationClass = animationDirection === 'to-forgot' ? 'slide-out-left' : 
                           animationDirection === 'to-login' ? 'slide-in-right' : '';
    
    return (
      <Container fluid className="px-0 login-container">
        <style>
        {`
          .login-container {
            background: linear-gradient(135deg, #f8f9fe 0%, #eef1f8 100%);
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
          }
          
          .login-card {
            border-radius: 12px;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
            border: none;
            overflow: hidden;
            max-width: 450px;
            margin: 2rem auto;
            background: white;
            transition: transform 0.3s ease, opacity 0.3s ease;
          }
          
          .login-header {
            background: linear-gradient(135deg, #21AA73 0%, #19af75 100%);
            padding: 2rem;
            text-align: center;
            margin-bottom: 1.5rem;
          }
          
          .login-logo {
            width: 180px;
            filter: brightness(0) invert(1);
            margin-bottom: 1rem;
          }
          
          .welcome-text {
            color: white;
            font-size: 1.2rem;
            font-weight: 300;
            margin-bottom: 0;
          }
          
          .login-form {
            padding: 0 2rem 2rem;
          }
          
          .form-label {
            font-size: 0.7rem;
            text-transform: uppercase;
            letter-spacing: 0.7px;
            font-weight: 600;
            color: #495057;
            margin-bottom: 0.5rem;
          }
          
          .input-with-icon {
            position: relative;
          }
          
          .input-icon {
            position: absolute;
            left: 12px;
            top: 50%;
            transform: translateY(-50%);
            color: #B3B5B9;
          }
          
          .form-input-styled {
            padding-left: 40px;
            height: 46px;
            border-radius: 8px;
            border: 1px solid #e1e5eb;
            font-size: 0.95rem;
            transition: all 0.2s ease;
          }
          
          .form-input-styled:focus {
            border-color: #21AA73;
            box-shadow: 0 0 0 0.2rem rgba(33, 170, 115, 0.25);
          }
          
          .login-btn {
            height: 46px;
            border-radius: 8px;
            font-weight: 500;
            font-size: 0.95rem;
            transition: all 0.2s ease;
            margin-top: 1rem;
            box-shadow: 0 4px 12px rgba(33, 170, 115, 0.2);
          }
          
          .login-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 15px rgba(33, 170, 115, 0.25);
          }
          
          .login-footer {
            margin-top: 1.5rem;
            text-align: center;
          }
          
          .footer-links {
            display: flex;
            justify-content: center;
            margin-bottom: 1rem;
          }
          
          .footer-link {
            color: #6c757d;
            font-size: 0.8rem;
            margin: 0 0.75rem;
            transition: color 0.2s;
          }
          
          .footer-link:hover {
            color: #21AA73;
            text-decoration: none;
          }
          
          .copyright {
            color: #9EA0A5;
            font-size: 0.75rem;
          }
          
          /* Animation classes */
          .slide-out-left {
            transform: translateX(-100px);
            opacity: 0;
          }
          
          .slide-in-right {
            animation: slideInRight 0.3s forwards;
          }
          
          @keyframes slideInRight {
            from {
              transform: translateX(100px);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
          
          @media (max-width: 576px) {
            .login-card {
              margin: 1rem;
              max-width: none;
            }
            
            .login-header {
              padding: 1.5rem;
            }
            
            .login-form {
              padding: 0 1.5rem 1.5rem;
            }
          }
        `}
        </style>
        
        <Row className="mx-0 w-100">
          <Col md="10" lg="8" xl="6" className="mx-auto">
            <Card className={`login-card ${animationClass}`}>
              <div className="login-header">
                <img 
                  src={require('../../images/enforceplus-logo.png')}
                  alt="EnforcePlus"
                  className="login-logo"
                />
                <p className="welcome-text">Welcome to EnforcePlus</p>
              </div>
              
              <div className="login-form">
                <Form>
                  <FormGroup>
                    <label className="form-label">Email Address</label>
                    <div className="input-with-icon">
                      <FontAwesomeIcon icon={faEnvelope} className="input-icon" />
                      <FormInput 
                        id="email"
                        className="form-input-styled"
                        placeholder="Enter your email"
                        onChange={event => this.setState({email: event.target.value})}
                      />
                    </div>
                  </FormGroup>
                  
                  <FormGroup>
                    <label className="form-label">Password</label>
                    <div className="input-with-icon">
                      <FontAwesomeIcon icon={faLock} className="input-icon" />
                      <FormInput
                        id="password"
                        className="form-input-styled"
                        placeholder="Enter your password"
                        type="password"
                        onChange={event => this.setState({password: event.target.value})}
                        invalid={this.props.loginFail}
                      />
                      <FormFeedback>Invalid email or password. Please try again.</FormFeedback>
                    </div>
                  </FormGroup>
                  
                  <FormGroup>
                    {!this.state.loggingIn ? (
                      <Button
                        theme="accent"
                        className="login-btn w-100 d-flex align-items-center justify-content-center"
                        onClick={() => {
                          this.props.authenticateWithEmailAddressAndPassword(this.state.email, this.state.password);
                          this.setState({loggingIn: true}, () => setTimeout(() => {
                            this.props.getLiveUsers()
                          }, 3000))
                        }}
                        disabled={!this.state.email || !this.state.password}
                      >
                        <FontAwesomeIcon icon={faSignInAlt} className="mr-2" />
                        Sign In
                      </Button>
                    ) : (
                      <Button disabled theme="accent" className="login-btn w-100">
                        <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                        Signing in...
                      </Button>
                    )}
                  </FormGroup>
                  
                  <div className="text-center mt-3">
                    <a href="#" onClick={this.props.goToForgotPassword} className="text-primary">Forgot password?</a>
                  </div>
                </Form>
              </div>
            </Card>
            
            <div className="login-footer">
              <div className="footer-links">
                <a href={`${WEBSITE_URL}/terms`} target="_blank" rel="noopener noreferrer" className="footer-link">Terms of Use</a>
                <a href={`${WEBSITE_URL}/privacy`} target="_blank" rel="noopener noreferrer" className="footer-link">Privacy Policy</a>
                <a href={WEBSITE_URL} target="_blank" rel="noopener noreferrer" className="footer-link">Website</a>
              </div>
              <div className="copyright">&copy; {new Date().getFullYear()} EnforcePlus LLC</div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default AnimatedLoginWrapper;
